const textSoundPlayer = {
    audio: null,
    ///检查是否初始化
    checkInit: function () {
        if (this.audio == null) {
            this.audio = new Audio();
            // 可选监听事件
            this.audio.onended = () => {
                console.log('音频播放完毕');
            };
            this.audio.onerror = (e) => {
                console.error('音频加载出错', e);
            };
        }
    },
    /**
     * 播放文本，返回 Promise，播放完毕或出错后resolve或reject。
     * @param {string} text 要播放的文本
     * @returns {Promise<void>}
     */
    playText: function (text) {
        this.checkInit();

        // 如果当前音频还在播放，先停止它
        if (!this.audio.paused) {
            this.audio.pause();
        }

        text = encodeURIComponent(text);
        var url = "http://media.comekey.com/Media/PlayText?text=" + text + "&lan=en&player=default-us&token=0";
        this.audio.src = url;

        return new Promise((resolve, reject) => {
            // 播放失败、加载错误时的处理
            const onError = (e) => {
                cleanup();
                reject(e);
            };
            // 播放结束时处理
            const onEnded = () => {
                cleanup();
                resolve();
            };

            // 清理事件监听，避免内存泄漏或事件触发多次
            const cleanup = () => {
                this.audio.removeEventListener('ended', onEnded);
                this.audio.removeEventListener('error', onError);
            };

            // 绑定事件监听
            this.audio.addEventListener('ended', onEnded);
            this.audio.addEventListener('error', onError);

            // 尝试开始播放
            const playPromise = this.audio.play();
            if (playPromise !== undefined) {
                playPromise.catch(err => {
                    cleanup();
                    reject(err);
                });
            }
        });
    }
};

export default textSoundPlayer;